import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";
import "./productCategory.css";

import { FilterOutlined } from "@ant-design/icons";
import { Badge, Button, Dropdown, Input, Menu, Popover, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllProductCategory } from "../../redux/actions/productCategory/getProductCategoryAction";

const FILTER_STYLE = { marginBottom: 12 };
const FILTER_LABEL = { display: "block", marginBottom: 4, color: "rgba(0,0,0,0.65)", fontSize: 12 };

function CustomTable({ list, addProductCategoryButton, uploadButton }) {
  const dispatch = useDispatch();
  const [columnItems, setColumnItems] = useState([]);
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterName, setFilterName] = useState("");

  const columns = [
    {
      title: "S.No",
      key: "sNo",

      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name, { id }) => (
        <Link to={`/product-category/${id}`}>{name}</Link>
      ),
    },
  ];

  const menuItems = columns.map((item) => ({
    key: item.key,
    label: <span>{item.title}</span>,
  }));

  useEffect(() => {
    setColumnItems(menuItems);
    setColumnsToShow(columns);
  }, []);

  const colVisibilityClickHandler = (col) => {
    const ifColFound = columnsToShow.find((item) => item.key === col.key);
    if (ifColFound) {
      const filteredColumnsToShow = columnsToShow.filter(
        (item) => item.key !== col.key
      );
      setColumnsToShow(filteredColumnsToShow);
    } else {
      const foundIndex = columns.findIndex((item) => item.key === col.key);
      const foundCol = columns.find((item) => item.key === col.key);
      let updatedColumnsToShow = [...columnsToShow];
      updatedColumnsToShow.splice(foundIndex, 0, foundCol);
      setColumnsToShow(updatedColumnsToShow);
    }
  };

  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

  const nameLower = (filterName || "").trim().toLowerCase();
  const filteredData = list && nameLower
    ? list.filter((item) => (item.name || "").toLowerCase().includes(nameLower))
    : list;
  const activeFilterCount = nameLower ? 1 : 0;

  const filterContent = (
    <div style={{ width: 260 }}>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Name</label>
        <Input
          placeholder="Filter by name"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          allowClear
        />
      </div>
      <div style={{ textAlign: "center", marginTop: 8 }}>
        <Button size="small" onClick={() => setFilterName("")}>
          Clear All Filters
        </Button>
      </div>
    </div>
  );

  return (
    <div className="card card-custom list-page-fill-viewport">
      <div className="card-body">
        <div className="card-title d-flex justify-content-between align-items-center list-page-header" style={{ marginBottom: 0 }}>
          <h5 className="mb-0">Product Category List</h5>
          <div className="pcat-header-actions">
            {list && (
              <>
                <Popover
                  content={filterContent}
                  title="Filters"
                  trigger="click"
                  open={filterVisible}
                  onOpenChange={setFilterVisible}
                  placement="bottomLeft"
                >
                  <Badge count={activeFilterCount} size="small" offset={[-2, 2]}>
                    <Button
                      type="primary"
                      className="filter-icon-btn"
                      icon={<FilterOutlined />}
                      onClick={() => setFilterVisible((v) => !v)}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </Badge>
                </Popover>
                <Dropdown
                  overlay={<Menu onClick={colVisibilityClickHandler} items={columnItems} />}
                  placement="bottomRight"
                >
                  <Button className="column-visibility">Column Visibility</Button>
                </Dropdown>
              </>
            )}
            {addProductCategoryButton}
            {uploadButton}
          </div>
        </div>

        <div className="list-page-table-container">
          <div className="list-page-table-inner">
            <div className="list-page-table-wrap">
              {/* Desktop Table */}
              <div className="d-none d-lg-block">
                <Table
                  scroll={{ x: true, y: 450 }}
                  loading={!list}
                  pagination={{
                    defaultPageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    showSizeChanger: true,
                    onChange: (page, limit) => {
                      dispatch(loadAllProductCategory({ page, limit }));
                    },
                  }}
                  columns={columnsToShow}
                  dataSource={filteredData ? addKeys(filteredData) : []}
                />
              </div>

              {/* Mobile cards */}
              <div className="d-lg-none product-category-mobile-cards">
                {filteredData && filteredData.length > 0 ? (
                  filteredData.map((record, idx) => (
                    <div key={record.id ?? idx} className="col-12 mb-2">
                      <div className="product-category-mobile-card card">
                        <div className="card-body">
                          <div className="product-category-mobile-row">
                            <span className="product-category-mobile-sno">{idx + 1}</span>
                            <Link
                              to={`/product-category/${record.id}`}
                              className="product-category-mobile-name"
                            >
                              {record.name}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5">
                    <p className="text-muted mb-0">No Product Categories found</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const GetAllProductCategory = ({ addProductCategoryButton, uploadButton, refreshTrigger }) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.productCategories?.list);

  useEffect(() => {
    dispatch(loadAllProductCategory({ page: 1, limit: 10 }));
  }, [dispatch, refreshTrigger]);

  return (
    <CustomTable
      list={list}
      addProductCategoryButton={addProductCategoryButton}
      uploadButton={uploadButton}
    />
  );
};

export default GetAllProductCategory;
